module.exports = __webpack_public_path__ + "static/media/Max65_in.3ec17c63.jpg";